import React from "react";
import { Box, Button, Divider, Grid, Paper, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { Link as RouterLink } from "react-router-dom";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

export default function BakerFlavors(props) {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          {props.editable && (
            <Box mb={2} align="right">
              <Button
                variant="outlined"
                color="secondary"
                disableElevation
                component={RouterLink}
                to={`/my/flavors/edit`}
                startIcon={<EditOutlinedIcon />}
                fullWidth
              >
                Edit Flavors
              </Button>
            </Box>
          )}
          <Paper elevation={3}>
            <Box p={2}>
              <Box>
                <Grid container alignItems="center">
                  <Grid item xs={10}>
                    <Typography variant="subtitle1">Flavors</Typography>
                  </Grid>
                </Grid>
                <Box mt={1} mb={2}>
                  <Divider />
                </Box>
              </Box>
              {props.flavors &&
                Object.entries(props.flavors)
                  .sort()
                  .map(([key, value]) => {
                    return <Row key={key} value={value} />;
                  })}
              {!props.flavors && <Typography color="textSecondary">Not yet available</Typography>}
            </Box>
          </Paper>
        </Grid>
        <Grid item sm={6} xs={12}>
          {props.editable && (
            <Box mb={2} align="right">
              <Button
                variant="outlined"
                color="secondary"
                disableElevation
                component={RouterLink}
                to={`/my/flavors/edit`}
                startIcon={<EditOutlinedIcon />}
                fullWidth
              >
                Edit Fillings
              </Button>
            </Box>
          )}
          <Paper elevation={3}>
            <Box p={2}>
              <Box>
                <Grid container alignItems="center">
                  <Grid item xs={10}>
                    <Typography variant="subtitle1">Fillings</Typography>
                  </Grid>
                </Grid>
                <Box mt={1} mb={1}>
                  <Divider />
                </Box>
              </Box>
              {props.fillings &&
                Object.entries(props.fillings)
                  .sort()
                  .map(([key, value]) => {
                    return <Row key={key} handle={props.baker} value={value} />;
                  })}
              {!props.fillings && <Typography color="textSecondary">Not yet available</Typography>}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

function Row(props) {
  return (
    <Box my={2}>
      <Box>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ wordWrap: "anywhere" }}>
              {props.value.name}
              {props.value.type === "premium" && <StarIcon style={{ fontSize: "1rem", paddingLeft: "3px" }} />}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {props.value.type === "premium" ? `Premium option. $${props.value.fee} surcharge. ` : ""}
              {props.value.desc}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
